module.exports = __webpack_public_path__ + "static/media/img_qa_title@2x.2909f446.png";